import React, { useState, useEffect } from "react";
import mtd from "../../Artifacts/img.png";
import offtake from "../../Artifacts/offtake.png";
import complaint from "../../Artifacts/complaint.png";
import leadesource from "../../Artifacts/leade_source.png";
import wsr from "../../Artifacts/wsr.png";
import management from "../../Artifacts/management.png";
import Insights from "../../Artifacts/Insights.png";
import Customer from "../../Artifacts/Customer360.svg";
import GTME from "../../Artifacts/gtme.png";
import v360 from "../../Artifacts/v360.png";
import Tops from "../../Artifacts/tops.jpg";
import pvin from "../../Artifacts/Cards/pvin.png";
import dealerReview from "../../Artifacts/Cards/dealerReview.png";
import dealerReviewUpload from "../../Artifacts/Cards/CollabXUpload.svg";
import pipline from "../../Artifacts/pipline.png";
import salesSuccess from "../../Artifacts/SalesSucessCenter/SlaesSC.png";
import Realization from "../../Artifacts/Realization/Realization.png";
import PowerDeck from "../../Artifacts/Powerdeck.svg";
import CollabaxService from "../../Artifacts/Cards/CollabXService.png";

import { Link } from "react-router-dom";
import { axInst } from "../../Components/Login/Service";

const Index = ({ menu }) => {
  const [dataObject, setDataObject] = useState({});

  const fetchDashboardAccessData = async () => {
    try {
      const res = await axInst.post(`dashboard`);
      const data = res.data;

      // Convert array to object
      const convertedObject = data.reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});

      // Add external "Insights" entry
      convertedObject["external"] = "Insights";

      setDataObject(convertedObject);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  useEffect(() => {
    fetchDashboardAccessData();
  }, []);

  const handleClick = async (dashboardName) => {
    const requestData = {
      dashboard_type: dashboardName,
    };
    try {
      await axInst.post(`user-logs`, requestData);
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div className="flex flex-col flex-grow gap-2">
      <div className="mt-1 p-4 w-full">
        {menu === "salesPreSales" && (
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
            {Object.values(dataObject).includes("Live Retail") && (
              <Link
                to="/Retail-Dashboard"
                title="Live Retail"
                onClick={() => {
                  handleClick("Live Retail");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={mtd}
                    alt="Live Retail"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Live Retail
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Live Offtake") && (
              <Link
                to="/Offtake-Dashboard"
                title="Live Offtake"
                onClick={() => {
                  handleClick("Live Offtake");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={offtake}
                    alt="Live Offtake"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Live Offtake
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Live Stock") && (
              <Link
                to="/Stock-Dashboard"
                title="Live Stock"
                onClick={() => {
                  handleClick("Live Stock");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={management}
                    alt="Live Stock"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Live stock
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Pipeline Summary") && (
              <Link
                to="/Pipeline"
                title="Pipeline Summary"
                onClick={() => {
                  handleClick("Pipeline Summary");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={pipline}
                    alt="Pipeline Summary"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Pipeline Summary
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Realization Summary") && (
              <Link
                to="/Realization"
                title="Realization"
                onClick={() => {
                  handleClick("Realization");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={Realization}
                    alt="Realization Summary"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Live Realization
                  </h2>
                </div>
              </Link>
            )}
          </div>
        )}

        {menu === "service" && (
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {Object.values(dataObject).includes("complaint") && (
              <Link
                to="/Complaint-Dashboard"
                title="Complaint"
                onClick={() => {
                  handleClick("complaint");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={complaint}
                    alt="Complaint"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Complaint
                  </h2>
                </div>
              </Link>
            )}
          </div>
        )}
        {menu === "DailyWorkManagement" && (
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
            {Object.values(dataObject).includes("Lead Source Metrics") && (
              <Link
                to="/Lead-Source"
                title="Lead Source Metrics"
                onClick={() => {
                  handleClick("Lead Source Metrics");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={leadesource}
                    alt="Lead Source Metrics"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Lead Source Metrics
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("WSR") && (
              <Link
                to="/WSR"
                title="WSR"
                onClick={() => {
                  handleClick("WSR");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img src={wsr} alt="WSR" className="mx-auto mb-4 h-[150px]" />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">WSR</h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("PVIN") && (
              <Link
                to="/Key-Accounts-Intelligence"
                title="Key Accounts Intelligence"
                onClick={() => {
                  handleClick("PVIN");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={pvin}
                    alt="Key Accounts Intelligence"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Key Accounts Intelligence
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Customer360") && (
              <Link
                to="/Customer360"
                title="Customer360"
                onClick={() => {
                  handleClick("CUSTOMER360");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={Customer}
                    alt="Key Accounts Intelligence"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Customer360
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Dealer Review") && (
              <Link
                to="/Dealer-Review"
                title="Dealer Review"
                onClick={() => {
                  handleClick("Dealer Review");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={dealerReview}
                    alt="Dealer Review"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    COLLABX
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes(
              "Dealer Review Upload Data",
            ) && (
              <Link
                to="/Dealer-Review-Upload-Data"
                title="Dealer Review Upload Data"
                onClick={() => {
                  handleClick("Dealer Review Upload Data");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={dealerReviewUpload}
                    alt="Dealer Review Upload Data"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    COLLABX Data Upload
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Sales Success Center") && (
              <Link
                to="/Sales-Success-Center"
                title="Sales Success Cente"
                onClick={() => {
                  handleClick("Sales Success Center");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={salesSuccess}
                    alt="Sales Success Center"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Sales Success Center
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Powerdeck") && (
              <Link
                to="/PowerDeck"
                title="Powerdeck"
                onClick={() => {
                  handleClick("Powerdeck");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={PowerDeck}
                    alt="Powerdeck"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    PowerDeck
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Service Collabax") && (
              <Link
                to="/Service-Collabax"
                title="Service Collabax"
                onClick={() => {
                  handleClick("service collabax");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={CollabaxService}
                    alt="Service COLLABX"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Service COLLABX (SCV&PU)
                  </h2>
                </div>
              </Link>
            )}
            {Object.values(dataObject).includes("Service Collabax Dealer") && (
              <Link
                to="/Dealer-Service-Collabax"
                title="Service COLLABX"
                onClick={() => {
                  handleClick("dealer service collabax");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={CollabaxService}
                    alt="Service Collabax"
                    className="mx-auto mb-4 h-[150px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Service COLLABX (SCV&PU)
                  </h2>
                </div>
              </Link>
            )}
          </div>
        )}
        {menu === "Others" && (
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
            {Object.values(dataObject).includes("Insights") && (
              <a
                href={`${process.env.REACT_APP_OTHER_URL}`}
                title="Insights(Analytics)"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleClick("Insights");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={Insights}
                    alt="Insights(Analytics)"
                    className="mx-auto mb-4 h-[150px] w-[250px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Insights(Analytics)
                  </h2>
                </div>
              </a>
            )}
            {Object.values(dataObject).includes("Insights") && (
              <a
                href={`${process.env.REACT_APP_GTME_URL}`}
                title="GTME"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleClick("GTME");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={GTME}
                    alt="GTME"
                    className="mx-auto mb-4 h-[150px] w-[250px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">GTME</h2>
                </div>
              </a>
            )}
            {Object.values(dataObject).includes("Insights") && (
              <a
                href={`${process.env.REACT_APP_CUSTOMER_URL}`}
                title="customer360"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleClick("customer360");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={Customer}
                    alt="customer360"
                    className="mx-auto mb-4 h-[150px] w-[250px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Customer360
                  </h2>
                </div>
              </a>
            )}
            {Object.values(dataObject).includes("Insights") && (
              <a
                href={`${process.env.REACT_APP_TOP_URL}`}
                title="TOPS"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleClick("Insights");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={Tops}
                    alt="TOPS"
                    className="mx-auto mb-4 h-[150px] w-[250px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">TOPS</h2>
                </div>
              </a>
            )}
            {Object.values(dataObject).includes("Insights") && (
              <a
                href={`${process.env.REACT_APP_VEHICLE_APP_URL}`}
                title="Vehicle360"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  handleClick("New App");
                }}
              >
                <div className="bg-white rounded-lg shadow p-3 text-center">
                  <img
                    src={v360}
                    alt="Vehicle360"
                    className="mx-auto mb-4 h-[150px] w-[250px]"
                  />
                  <hr />
                  <h2 className="text-xl font-semibold text-[#2A5775]">
                    Vehicle360
                  </h2>
                </div>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Index;
